import { ThemeKey } from "@smartsheet/design-tokens";
import React, { forwardRef } from "react";
import { useTheme } from "../../theme/utils/useTheme";
import { TabUnderlineStyled } from "./TabUnderlineStyled";

export interface TabUnderlineProps {
    backgroundColor: string;
    leftPx: number;
    widthPlusUnit: string;
    height?: string;
    underlineTransition?: boolean;
}

export const TabUnderline = forwardRef<HTMLDivElement, TabUnderlineProps>((props, ref) => {
    const { key } = useTheme();
    const themeMode = key as ThemeKey;
    return <TabUnderlineStyled themeMode={themeMode} ref={ref} {...props} />;
});

TabUnderline.displayName = "TabUnderline";
